import axios from "axios";
import { userServiceUrl } from "../../Config/config";
import { Authme } from "../../Utils/utils";

export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAILURE = "USER_FAILURE";

const createAction = (type, payload = null) => ({ type, payload });

export const UserData = (id) => async (dispatch) => {
  dispatch(createAction(USER_REQUEST));
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      const errorMessage = "No token found";
      dispatch(createAction(USER_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    const response = await Authme()

    if (response.data) {
      dispatch(createAction(USER_SUCCESS, response.data));
    } else {
      const errorMessage = "Invalid response structure";
      dispatch(createAction(USER_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
    dispatch(createAction(USER_FAILURE, errorMessage));
    console.error(error);
    throw new Error(errorMessage);
  }
};
